import { render, staticRenderFns } from "./CLessonBranch.vue?vue&type=template&id=3e48e88c"
import script from "./CLessonBranch.vue?vue&type=script&lang=js"
export * from "./CLessonBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports